import React from "react"
import { css } from "@emotion/core"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { landscapingPageMetadata } from "../../../utils/seo"

import * as mixins from "../../../utils/mixins"

import TopDisplayImageCont from "../../components/imageComponents/TopDisplayImageCont"
import TopImage from "../../components/imageComponents/optimized/home"
import { MethodsTopImageTitle } from "../../components/layoutComponents/top-image-title"

import * as TextComponent from "../../components/textComponents"
import * as LayoutComponent from "../../components/layoutComponents"
import * as InteractiveComponent from "../../components/interactiveComponents"

import LandscapingSecondaryImage from "../../components/imageComponents/planning/planning-three"

import {
  HeaderNavBar,
  HeaderNavBarBackLink,
} from "../../components/layoutComponents/header-nav-bar"

function InstallationPage() {
  return (
    <Layout>
      <SEO
        title="Landscaping"
        description="Marin County and area's source for the quality and reasonable priced landscaping services."
        meta={landscapingPageMetadata}
      />
      <HeaderNavBar>
        <HeaderNavBarBackLink to="/">BACK TO SERVICES</HeaderNavBarBackLink>
      </HeaderNavBar>

      <TopDisplayImageCont>
        <TopImage />
        <MethodsTopImageTitle />
      </TopDisplayImageCont>

      <LayoutComponent.SectionContainer
        styles={css`
          ${mixins.device.mobileX} {
            padding-bottom: 0.15rem;
          }
        `}
      >
        <TextComponent.BodyText>
          There&apos;s a lot more to landscaping than just moving dirt. We adopt
          the latest innovations and cutting-edge tech to do our job faster and
          better. This means cost-savings for you.
        </TextComponent.BodyText>
      </LayoutComponent.SectionContainer>

      <div
        css={css`
          /* height: 14rem; */
          max-height: 10rem;

          ${mixins.device.tablet} {
            max-height: 14rem;
          }
        `}
      >
        <LandscapingSecondaryImage />
      </div>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText
          styles={css`
            margin: 1rem 0 1.5rem;

            ${mixins.device.mobileX} {
              margin: 0.5rem 0 1.65rem;
            }
          `}
        >
          <TextComponent.BodyBold>Have questions?</TextComponent.BodyBold> Get
          in touch, we’d love to find out how we can save you time and money on
          your project.
        </TextComponent.BodyText>

        <InteractiveComponent.Button to="/contact-us/">
          CONTACT US
        </InteractiveComponent.Button>
      </LayoutComponent.SectionContainer>
    </Layout>
  )
}

export default InstallationPage
